import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'Kit de Entrega Inmediata para Pacientes',
  desc: 'Qué material dar en cada consulta y en qué orden, para maximizar el impacto desde el día uno.',
  image: 'https://cdn.magicpatterns.com/uploads/rACVkZSYRUqvwLwXgPBEP2/bonus_1_-_Kit_de_Entrega_Inmediata_para_Pacientes.webp'
}, {
  num: 2,
  title: 'Checklist de Adherencia Clínica',
  desc: 'Detectá en minutos por qué un paciente no cumple el protocolo y corregilo sin rehacer el tratamiento.',
  image: 'https://cdn.magicpatterns.com/uploads/rBkEAR8mw4JinDcKLZcGoJ/bonus_2_-_Checklist_de_Adherencia_Clinica_del_Paciente.webp'
}, {
  num: 3,
  title: 'Guía de Explicación Simple',
  desc: 'Frases puente para traducir protocolos complejos en indicaciones claras que cualquier paciente entiende.',
  image: 'https://cdn.magicpatterns.com/uploads/v3S5cjDEb7qTokAW89Q9i9/bonus_3_-_Guia_de_Explicacion_Simple_para_Pacientes_Dificiles.webp'
}, {
  num: 4,
  title: 'Planificador de Seguimiento Semanal',
  desc: 'Fichas de control rápido para registrar síntomas, adherencia y próximos pasos en cada control.',
  image: 'https://cdn.magicpatterns.com/uploads/f42BNvvJdCkJknxdTLhh2t/bonus_4_-_Planificador_Clinico_de_Seguimiento_Semanal.webp'
}, {
  num: 5,
  title: 'Banco de 12 Checklists Imprimibles',
  desc: 'Listas listas para imprimir o enviar por WhatsApp: primera consulta, seguimiento, mantenimiento y más.',
  image: 'https://cdn.magicpatterns.com/uploads/21GYnRuHNLyzuUG5NV2S2n/bonus_5_-_Banco_de_Checklists_Clinicas_Listas_para_Imprimir.webp'
}];
export function BonusesSection() {
  return <section className="py-12 md:py-16 bg-emerald-50" data-id="element-12">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-13">
        <div className="text-center mb-10" data-id="element-14">
          <span className="inline-flex items-center gap-2 px-6 py-2.5 mb-5 rounded-full border border-emerald-200 bg-white text-emerald-800 font-bold tracking-[0.15em] uppercase text-xs shadow-sm" data-id="element-15">
            <Gift className="w-4 h-4 text-emerald-600" data-id="element-16" /> Material
            Complementario
          </span>
          <h2 className="font-heading font-bold text-slate-900 text-3xl md:text-5xl leading-tight" data-id="element-17">
            Y además, te llevás estos{' '}
            <span className="text-emerald-700" data-id="element-18">Bonos Exclusivos</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-19">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white border border-emerald-100 rounded-xl shadow-sm hover:shadow-md transition-shadow flex items-center gap-3 p-3" data-id="element-20">
              <div className="relative flex-shrink-0 w-16 h-16 rounded-lg bg-emerald-900 flex items-center justify-center p-1.5" data-id="element-21">
                <img src={b.image} alt={`Bono ${b.num}: ${b.title}`} width={120} height={120} loading="lazy" decoding="async" className="max-w-full max-h-full w-auto h-auto object-contain rounded" data-id="element-22" />
              </div>
              <div className="min-w-0 flex-grow" data-id="element-23">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-24">
                  <span className="bg-yellow-400 text-yellow-900 text-[9px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wide flex-shrink-0" data-id="element-25">
                    Bono {b.num} · Gratis
                  </span>
                </div>
                <h3 className="font-heading font-bold text-slate-900 text-sm leading-snug" data-id="element-26">
                  {b.title}
                </h3>
                <p className="text-slate-500 text-xs leading-snug mt-0.5" data-id="element-27">
                  {b.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}